import styled from 'styled-components';

const Container = styled.div`
  height: 100vh;
  background: linear-gradient(180deg, #110a2e 0%, #7bd6dc 100%);
  overflow-y: scroll;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 980px) {
    justify-content: space-evenly;
  }
`;

const Profile = styled.div`
  width: 100%;
  height: 26rem;
  padding-top: 5rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > img {
    width: 10rem;
    margin-bottom: 3rem;
  }

  > h1 {
    font-size: 2.6rem;
    font-weight: 700;
    color: #fff;
  }

  > h2 {
    font-size: 2rem;
    font-weight: 400;
    color: #fff;
    letter-spacing: 0.5rem;
  }
`;

const Content = styled.div`
  width: 100%;
  height: calc(100vh - 26rem);
  margin-top: 2rem;
  border-top-left-radius: 5rem;
  border-top-right-radius: 5rem;
  padding: 2rem 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 980px) {
    width: 80%;
    border-radius: 5rem;
  }

  @media (min-width: 1560px) {
    width: 80rem;
  }
`;

const SubtitleContainer = styled.div`
  align-self: flex-start;
  margin: 2rem 0;
  padding-left: 2rem;

  display: flex;
  flex-direction: column;

  > h2 {
    font-size: 2.2rem;
    color: #fff;
  }

  .line-division {
    width: 100%;
    height: 0.1rem;
    background: linear-gradient(90deg, #61dafb 0%, #9b79fc 100%);
  }
`;

const CardGroup = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export { Container, Profile, Content, SubtitleContainer, CardGroup };
